module.exports = __webpack_public_path__ + "img/hvezda1.45dd5470.png";